// Custom icon static resources

import {
  ApartmentOutline,
  BulbOutline,
  CheckOutline,
  DeleteOutline,
  EditOutline,
  ExceptionOutline,
  InfoOutline,
  KeyOutline,
  LinkOutline,
  MedicineBoxOutline,
  PhoneOutline,
  PictureOutline,
  PlusOutline,
  ProfileOutline,
  SafetyCertificateOutline,
  SearchOutline,
  ShopOutline,
  UploadOutline,
  UsergroupAddOutline,
  VideoCameraOutline
} from '@ant-design/icons-angular/icons';

export const ICONS = [
  InfoOutline,
  BulbOutline,
  ProfileOutline,
  ExceptionOutline,
  LinkOutline,
  PhoneOutline,
  VideoCameraOutline,
  CheckOutline,
  DeleteOutline,
  EditOutline,
  MedicineBoxOutline,
  PictureOutline,
  PlusOutline,
  SearchOutline,
  UploadOutline,
  SafetyCertificateOutline,
  KeyOutline,
  ApartmentOutline,
  ShopOutline,
  UsergroupAddOutline
];
